import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Row, Column } from '../../../../../../components/grid/Grid';
import {
  Breadcrumb,
  BreadcrumbType,
} from '../../../../../../components/breadcrumb/Breadcrumb';
import { MaterialIcon } from '../../../../../../components/material-icon/MaterialIcon';
import { Hyperlink } from '../../../../../../components/Hyperlink';

import { LegislationInfos } from '../../../../legislation.types';

import styles from './content_header_top_component.module.scss';

type Props = {
  breadcrumbs: BreadcrumbType | null;
  previous: LegislationInfos | null;
  next: LegislationInfos | null;
};

export const ContentHeaderTopComponent: FC<Props> = ({
  breadcrumbs,
  previous,
  next,
}) => {
  return (
    <Row>
      <Column medium={12} large={8}>
        <Breadcrumb breadcrumbs={breadcrumbs || []} shortVersion />
      </Column>
      {(previous || next) && (
        <Column medium={12} large={4} className={styles.topNavigationContainer}>
          {previous?.articleId && (
            <Hyperlink
              href={previous?.url}
              source="previous_article"
              className={styles.navigationLink}
            >
              <MaterialIcon
                name="keyboard_arrow_left"
                className={styles.navigationIcon}
              />
              <span className={styles.previous}>
                <FormattedMessage
                  id="page/components/ContentHeaderTopComponent.tsx/1"
                  values={{ number: previous.articleNumber }}
                />
              </span>
            </Hyperlink>
          )}
          {next?.articleId && (
            <Hyperlink
              href={next?.url}
              source="next_article"
              className={styles.navigationLink}
            >
              <span className={styles.next}>
                <FormattedMessage
                  id="page/components/ContentHeaderTopComponent.tsx/1"
                  values={{ number: next.articleNumber }}
                />
              </span>
              <MaterialIcon
                name="keyboard_arrow_right"
                className={styles.navigationIcon}
              />
            </Hyperlink>
          )}
        </Column>
      )}
    </Row>
  );
};
